import React, { useCallback } from 'react';
import { Card, Button, Typography, Space } from 'antd';
import { LockOutlined, LogoutOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../stores/auth-store';

export default function UserModeSignOutPrompt() {
  const { logout, userEmail } = useAuth();
  const navigate = useNavigate();

  const handleSignOut = useCallback(() => {
    logout();
  }, [logout]);

  const handleCancel = useCallback(() => {
    navigate('/my-dashboard');
  }, [navigate]);

  return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#faf7f2', padding: 24 }}>
      <Card style={{ maxWidth: 440, width: '100%', borderRadius: 12 }}>
        <Space direction="vertical" size="middle" style={{ width: '100%', textAlign: 'center' }}>
          <LockOutlined style={{ fontSize: 36, color: '#005F73' }} />
          <Typography.Title level={4} style={{ margin: 0 }}>You are already signed in</Typography.Title>
          <Typography.Text type="secondary">
            Signed in as <strong>{userEmail}</strong>.
            Sign out to log in with a different account using username and password.
          </Typography.Text>
          <Button type="primary" size="large" block icon={<LogoutOutlined />} onClick={handleSignOut}>
            Sign out
          </Button>
          <Button type="link" onClick={handleCancel}>Cancel — return to dashboard</Button>
        </Space>
      </Card>
    </div>
  );
}
